import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';


/**
 * EC使用画像指示画面を管理するクラス
 *
 * @export KYMW5002UseImageComponent
 * @class KYMW5002UseImageComponent
 */
@Component({
  selector: 'app-kymw5002-use-image',
  templateUrl: 'kymw5002-use-image.component.html',
  styleUrls: ['kymw5002-use-image.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW5002UseImageComponent implements OnInit {

  @ViewChild('hli_UseImageList', { static: true }) hli_UseImageList: ElementRef;
  @ViewChild('useImageGroups', { static: true }) useImageGroups: ElementRef;

  @Input() useImageList: Array<any> = null;

  @Output() eventUseImageList_ITEMCLICK: EventEmitter<any> = new EventEmitter;

  /**
   *Creates an instance of KYMW5002UseImageComponent.
   * @param {PlessDialogServiceSub} dialogServiceSub
   * @memberof KYMW5002UseImageComponent
   */
  constructor(
    private dialogServiceSub: PlessDialogServiceSub,
  ) {
  }

  /**
   * 初期処理
   *
   * @memberof PhaseRegistComponent
   */
  public ngOnInit(): void {
  }
}
